let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("51qYO")).then(() => parcelRequire('6Ru1J'));